import Login from "../components/Login";
import Dashboard from "../components/Dashboard/Dashboard";
import AdminPanel from "../components/AdminPanel";

import CargaCombustible from "../components/Combustible/CargaCombustible";
import GenerarQr from "../components/Combustible/GenerarQr";
import React from "react";
import ModulesComponent from "../components/Administracion/ModuleList";
import RolesComponent from "../components/Administracion/RolesManagement";
import RolesPermissions from "../components/Administracion/RolesPermissionsList";
import UsersComponent from "../components/Administracion/UserManagement";
import UsersPermissions from "../components/Administracion/UsersPermissionsList";
import MenuOptionListComponent from "../components/Administracion/MenuOptionList";
import PermissionList from "../components/Administracion/PermissionList";
import AdminWrapper from "../components/Administracion/AdminWrapper";
import CombustibleWrapper from "../components/Administracion/CombustibleWrapper";
import CitasWrapper from "../components/Citas/CitasWrapper";
//import CitaForm from "../components/Citas/AdministrarCitas";
import AgendarVisitaPage from "../components/Citas/AgendarVisitaPage";
import BuildingsComponent from "../components/Citas/BuildingsList";
import ParkingsComponent from "../components/Citas/ParkingsList";
import PersonaVetadaComponent from "../components/Citas/PersonaVetadaList";
import ControlAccesoVisitas from "../components/Citas/ControlAccesoVisitas";
import PanelSupervisorVisitas from "../components/Citas/SupervisorVisitas";
import { RouteConfig } from "../types/routeConfigType";
import HistorialConsumoCombustible from "../components/Combustible/HistorialConsumoCombustible";
import GenerateQRCodeList from "../components/Combustible/GenerarQRList";
import MercadeoWraper from "../components/Mercadeo/MercadeoWraper";
import ImageManager from "../components/Mercadeo/ImageManager";
import MetadataManager from "../components/Mercadeo/MetadataManager";
import S3MetadataManager from "../components/Mercadeo/S3MetadataManager";

export const ROUTES: { [key: string]: RouteConfig[] } = {
  public: [
    {
      path: "/",
      element: React.createElement(Login),
      isProtected: false,
      label: "Login",
    },
  ],
  Administrador: [
    {
      label: "Dashboard",
      icon: "fas fa-chart-line",
      path: "/dashboard",
      isProtected: true,
      element: React.createElement(Dashboard),
    },
    {
      label: "Administración",
      icon: "fas fa-cogs",
      //path: '/admin',
      isProtected: true,
      element: React.createElement(AdminWrapper),
      children: [
        {
          path: "/modules",
          element: React.createElement(ModulesComponent),
          label: "Módulos",
          isProtected: true,
        },
        {
          path: "/menuOptions",
          element: React.createElement(MenuOptionListComponent),
          label: "Opciones de Menú",
          isProtected: true,
        },
        {
          path: "/permissions",
          element: React.createElement(PermissionList),
          label: "Permisos",
          isProtected: true,
        },
        {
          path: "/roles",
          element: React.createElement(RolesComponent),
          label: "Roles",
          isProtected: true,
        },
        {
          path: "/rolesPermisions",
          element: React.createElement(RolesPermissions),
          label: "Asignar Permisos a roles",
          isProtected: true,
        },
        {
          path: "/users",
          element: React.createElement(UsersComponent),
          label: "Usuarios",
          isProtected: true,
        },
        {
          path: "/usersPermisions",
          element: React.createElement(UsersPermissions),
          label: "Asignar Permisos a usuarios",
          isProtected: true,
        },
        {
          path: "/buildings",
          element: React.createElement(BuildingsComponent),
          label: "Edificios",
          isProtected: true,
        },
        {
          path: "/parkings",
          element: React.createElement(ParkingsComponent),
          label: "Parqueos",
          isProtected: true,
        },
        {
          path: "/admin-panel",
          element: React.createElement(AdminPanel),
          isProtected: true,
          label: "Panel de Administración",
        },
      ],
    },
    {
      label: "Combustible",
      icon: "fa-solid fa-gas-pump",
      //path: '/combustible',
      isProtected: true,
      element: React.createElement(CombustibleWrapper),
      children: [
        {
          path: "/captura-combustible",
          element: React.createElement(CargaCombustible),
          isProtected: true,
          label: "Captura Combustible",
        },
        {
          path: "/genera-qrList",
          element: React.createElement(GenerateQRCodeList),
          isProtected: true,
          label: "Generar lista QR ",
        },
        {
          path: "/genera-qr",
          element: React.createElement(GenerarQr),
          isProtected: true,
          label: "Generar QR",
        },
        {
          path: "/historialCombustible",
          element: React.createElement(HistorialConsumoCombustible),
          isProtected: true,
          label: "Reporte de Consumo",
        },
      ],
    },
    {
      label: "Visitas",
      icon: "fa-solid fa-calendar-check",
      //path: '/combustible',
      isProtected: true,
      element: React.createElement(CitasWrapper),
      children: [
        {
          path: "/Personas-Vetadas",
          element: React.createElement(PersonaVetadaComponent),
          isProtected: true,
          label: "Personas Vetadas",
        },
        {
          path: "/crear-cita",
          element: React.createElement(AgendarVisitaPage),
          isProtected: true,
          label: "Crear Visita",
        },
        {
          path: "/panel-supervisor-visitas",
          element: React.createElement(PanelSupervisorVisitas),
          isProtected: true,
          label: "Monitoreo de Visitas",
        },
        {
          path: "/control-acceso-visitas",
          element: React.createElement(ControlAccesoVisitas),
          isProtected: true,
          label: "Control de Acceso de Visitas",
        },
      ],
    },
    {
      label: "Mercadeo",
      icon: "fa-solid fa-comment-dollar",
      //path: '/combustible',
      isProtected: true,
      element: React.createElement(MercadeoWraper),
      children: [
        {
          path: "/admin-imagenes",
          element: React.createElement(ImageManager),
          isProtected: true,
          label: "Administración de Imágenes",
        },
        {
          path: "/admin-metadatos-imagenes",
          element: React.createElement(MetadataManager),
          isProtected: true,
          label: "Administración de metadatos de Imágenes",
        },
        {
          path: "/admin-s3-metadatos-imagenes",
          element: React.createElement(S3MetadataManager),
          isProtected: true,
          label: "Administración de metadatos S3 de Imágenes",
        },
      ],
    },
  ],
  Administrativos: [
    {
      label: "Dashboard",
      icon: "fas fa-chart-line",
      path: "/dashboard",
      isProtected: true,
      element: React.createElement(Dashboard),
    },
    {
      label: "Visitas",
      icon: "fa-solid fa-calendar-check",
      //path: '/combustible',
      isProtected: true,
      element: React.createElement(CitasWrapper),
      children: [
        /* {
          path: "/Personas-Vetadas",
          element: React.createElement(PersonaVetadaComponent),
          isProtected: true,
          label: "Personas Vetadas",
        }, */
        {
          path: "/crear-cita",
          element: React.createElement(AgendarVisitaPage),
          isProtected: true,
          label: "Crear Visita",
        } /* ,
        {
          path: "/panel-supervisor-visitas",
          element: React.createElement(PanelSupervisorVisitas),
          isProtected: true,
          label: "Monitoreo de Visitas",
        }, */,
        /* {
          path: "/control-acceso-visitas",
          element: React.createElement(ControlAccesoVisitas),
          isProtected: true,
          label: "Control de Acceso de Visitas",
        }, */
      ],
    },
  ],
  "Jefe de Seguridad": [
    {
      label: "Dashboard",
      icon: "fas fa-chart-line",
      path: "/panel-supervisor-visitas",
      isProtected: true,
      element: React.createElement(PanelSupervisorVisitas),
    },
    {
      label: "Visitas",
      icon: "fa-solid fa-calendar-check",
      //path: '/combustible',
      isProtected: true,
      element: React.createElement(CitasWrapper),
      children: [
        {
          path: "/Personas-Vetadas",
          element: React.createElement(PersonaVetadaComponent),
          isProtected: true,
          label: "Personas Vetadas",
        },
        {
          path: "/crear-cita",
          element: React.createElement(AgendarVisitaPage),
          isProtected: true,
          label: "Crear Visita",
        },
        {
          path: "/panel-supervisor-visitas",
          element: React.createElement(PanelSupervisorVisitas),
          isProtected: true,
          label: "Monitoreo de Visitas",
        } /* ,
        {
          path: "/control-acceso-visitas",
          element: React.createElement(ControlAccesoVisitas),
          isProtected: true,
          label: "Control de Acceso de Visitas",
        }, */,
      ],
    },
  ],
  Seguridad: [
    /* {
      label: "Dashboard",
      icon: "fas fa-chart-line",
      path: "/panel-supervisor-visitas",
      isProtected: true,
      element: React.createElement(PanelSupervisorVisitas),
    }, */
    {
      label: "Visitas",
      icon: "fa-solid fa-calendar-check",
      //path: '/combustible',
      isProtected: true,
      element: React.createElement(CitasWrapper),
      children: [
        /* {
          path: "/Personas-Vetadas",
          element: React.createElement(PersonaVetadaComponent),
          isProtected: true,
          label: "Personas Vetadas",
        }, */
        /* {
          path: "/crear-cita",
          element: React.createElement(AgendarVisitaPage),
          isProtected: true,
          label: "Crear Visita",
        },
        {
          path: "/panel-supervisor-visitas",
          element: React.createElement(PanelSupervisorVisitas),
          isProtected: true,
          label: "Monitoreo de Visitas",
        }, */
        {
          path: "/control-acceso-visitas",
          element: React.createElement(ControlAccesoVisitas),
          isProtected: true,
          label: "Control de Acceso de Visitas",
        },
      ],
    },
  ],
  Camionera: [
    {
      label: "Dashboard",
      icon: "fas fa-chart-line",
      path: "/panel-supervisor-visitas",
      isProtected: true,
      element: React.createElement(PanelSupervisorVisitas),
    },
    {
      label: "Visitas",
      icon: "fa-solid fa-calendar-check",
      //path: '/combustible',
      isProtected: true,
      element: React.createElement(CitasWrapper),
      children: [
        /* {
          path: "/Personas-Vetadas",
          element: React.createElement(PersonaVetadaComponent),
          isProtected: true,
          label: "Personas Vetadas",
        }, */
        {
          path: "/crear-cita",
          element: React.createElement(AgendarVisitaPage),
          isProtected: true,
          label: "Crear Visita",
        },
        {
          path: "/panel-supervisor-visitas",
          element: React.createElement(PanelSupervisorVisitas),
          isProtected: true,
          label: "Monitoreo de Visitas",
        },
        {
          path: "/control-acceso-visitas",
          element: React.createElement(ControlAccesoVisitas),
          isProtected: true,
          label: "Control de Acceso de Visitas",
        },
      ],
    },
  ],
  Pistero: [
    {
      label: "Dashboard",
      icon: "fas fa-chart-line",
      path: "/dashboard",
      isProtected: true,
      element: React.createElement(Dashboard),
    },
    {
      label: "Combustible",
      icon: "fa-solid fa-gas-pump",
      //path: '/combustible',
      isProtected: true,
      children: [
        {
          path: "/captura-combustible",
          element: React.createElement(CargaCombustible),
          isProtected: true,
          label: "Captura Combustible",
        },
        {
          path: "/genera-qr",
          element: React.createElement(GenerarQr),
          isProtected: true,
          label: "Generar QR",
        },
      ],
    },
  ],
  "Supervisor de Taller": [
    {
      label: "Combustible",
      icon: "fa-solid fa-gas-pump",
      //path: '/combustible',
      isProtected: true,
      children: [
        {
          path: "/genera-qrList",
          element: React.createElement(GenerateQRCodeList),
          isProtected: true,
          label: "Generar lista QR ",
        },
        /* {
          path: "/genera-qr",
          element: React.createElement(GenerarQr),
          isProtected: true,
          label: "Generar QR",
        }, */
        {
          path: "/historialCombustible",
          element: React.createElement(HistorialConsumoCombustible),
          isProtected: true,
          label: "Reporte de Consumo",
        },
      ],
    },
    {
      label: "Visitas",
      icon: "fa-solid fa-calendar-check",
      //path: '/combustible',
      isProtected: true,
      element: React.createElement(CitasWrapper),
      children: [
        {
          path: "/crear-cita",
          element: React.createElement(AgendarVisitaPage),
          isProtected: true,
          label: "Crear Visita",
        },
      ],
    },
  ],
  Mercadeo: [
    {
      label: "Mercadeo",
      icon: "fa-solid fa-comment-dollar",
      //path: '/combustible',
      isProtected: true,
      element: React.createElement(MercadeoWraper),
      children: [
        {
          path: "/admin-imagenes",
          element: React.createElement(ImageManager),
          isProtected: true,
          label: "Administración de Imágenes",
        },
        // {
        //   path: "/admin-metadatos-imagenes",
        //   element: React.createElement(MetadataManager),
        //   isProtected: true,
        //   label: "Administración de metadatos de Imágenes",
        // },
        // {
        //   path: "/admin-s3-metadatos-imagenes",
        //   element: React.createElement(S3MetadataManager),
        //   isProtected: true,
        //   label: "Administración de metadatos S3 de Imágenes",
        // }
      ],
    },
  ],
};
